/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/downloadsMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Downloads. */
export class Downloads {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Downloads.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * @summary Gets download links.
   * @param [options] The optional parameters
   * @returns Promise<Models.DownloadsGetAllResponse>
   */
  getAll(options?: coreHttp.RequestOptionsBase): Promise<Models.DownloadsGetAllResponse>;
  /**
   * @param callback The callback
   */
  getAll(callback: coreHttp.ServiceCallback<Models.AppLinksSettings>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAll(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.AppLinksSettings>): void;
  getAll(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.AppLinksSettings>, callback?: coreHttp.ServiceCallback<Models.AppLinksSettings>): Promise<Models.DownloadsGetAllResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAllOperationSpec,
      callback) as Promise<Models.DownloadsGetAllResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getAllOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/Downloads",
  responses: {
    200: {
      bodyMapper: Mappers.AppLinksSettings
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
